export interface GrantedRolesRepresentation {
  roles: Map<string, Role[]>;
}

export enum Role {
  ADMIN = 'ADMIN',
}
